module.exports = __webpack_public_path__ + "img/event.f5d4b425.svg";